<template>
    <div class="scientific-article">
        <a id="viber_share" style="display: none;" href=""></a>

        <author-popup @closePopup="closePopup()" :currentResearchTitle="articleItem.title" :authorInfo="authorInfo" v-if="isAuthorInfoOpen" />
        <edition-popup @closePopup="closePopup()" :currentResearchTitle="articleItem.title" :editionInfo="editionInfo" v-if="isEditionInfoOpen" />
        <product-popup @closePopup="closePopup()" :productInfo="productInfo" v-if="isProductInfoOpen" />
        <language-popup @closePopup="closePopup()" :action="action" :contentUa="articleItem.contentUa" :contentRu="articleItem.contentRu" :contentEn="articleItem.contentEn" v-if="action" />

        <div class="article-header">
            <div class="article-type">Клінічне дослідження</div>
            <div class="language">
                <div class="ukr" v-if="articleItem.contentEn || articleItem.contentRu">УКР</div>
                <div class="delimetr" v-if="articleItem.contentEn">|</div>
                <div class="en" v-if="articleItem.contentEn">EN</div>
                <div class="delimetr" v-if="articleItem.contentRu">|</div>
                <div class="ru" v-if="articleItem.contentRu">РУС</div>
            </div>
        </div>

        <div class="article-content">

            <div class="article-title">
                <div class="image">
                    <svg width="59" height="90" viewBox="0 0 59 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.5 7.61405C0.5 7.37994 0.673463 7.18206 0.905562 7.15141L50.2056 0.640086C50.4851 0.603161 50.7333 0.82073 50.7333 1.10273V82.2859C50.7333 82.5201 50.5599 82.7179 50.3278 82.7486L1.02777 89.2599C0.748195 89.2968 0.5 89.0793 0.5 88.7973V7.61405Z" fill="#CEBFE0" stroke="#AC98C5"/>
                        <path d="M0.5 7.66883C0.5 7.42358 0.689828 7.22018 0.934491 7.20327L53.4885 3.5711C53.7605 3.5523 53.9906 3.76969 53.9873 4.04231L53.0107 84.6143C53.0078 84.8551 52.8222 85.0541 52.5823 85.0738L1.00491 89.3157C0.733016 89.338 0.5 89.1234 0.5 88.8506V7.66883Z" fill="#DCCFEB" stroke="#AC98C5"/>
                        <mask id="path-3-inside-1" fill="white">
                        <rect y="6.7666" width="58" height="83.1333" rx="0.966667"/>
                        </mask>
                        <rect y="6.7666" width="58" height="83.1333" rx="0.966667" fill="#F1EDF7" stroke="#AC98C5" stroke-width="2" mask="url(#path-3-inside-1)"/>
                        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="2" y="45" width="54" height="43">
                        <rect x="2.55859" y="45.7354" width="52.8824" height="41.5667" fill="#BCD7F0"/>
                        </mask>
                        <g mask="url(#mask0)">
                        <g opacity="0.7">
                        <path d="M20.2752 72.8991H23.9762C24.3575 72.8991 24.6667 73.2125 24.6667 73.5991C24.6667 73.9857 24.3575 74.2992 23.9762 74.2992H22.7402C24.0884 77.0825 26.9518 78.7745 30.005 78.5919C33.0583 78.4093 35.7056 76.3877 36.7216 73.463C37.7377 70.5382 36.9243 67.2809 34.6579 65.1986C34.1859 64.7651 33.4842 64.1635 33.027 63.8269C32.8311 64.0288 31.9866 64.7777 31.4126 65.3597C31.5385 65.8393 31.4045 66.3507 31.0605 66.7037L30.0869 67.6978C29.828 67.9581 29.478 68.1041 29.1133 68.1038C28.4229 68.1038 28.0845 67.6488 27.6426 67.2008L26.2133 68.6988C25.9543 68.9617 25.6028 69.1095 25.2363 69.1095C24.8698 69.1095 24.5183 68.9617 24.2593 68.6988L22.3121 66.7177C22.0528 66.4551 21.9071 66.0988 21.9071 65.7272C21.9071 65.3556 22.0528 64.9992 22.3121 64.7366L23.776 63.2525L23.2857 62.7625C23.0264 62.4999 22.8807 62.1435 22.8807 61.7719C22.8807 61.4004 23.0264 61.044 23.2857 60.7814L24.2593 59.7873C24.609 59.436 25.1167 59.3 25.5919 59.4303L35.4933 49.3777C35.7524 49.1148 36.1038 48.9671 36.4704 48.9671C36.8369 48.9671 37.1884 49.1148 37.4474 49.3777L39.3945 47.4106C39.6535 47.1477 40.005 47 40.3715 47C40.7381 47 41.0895 47.1477 41.3486 47.4106L43.3095 49.3847C43.5688 49.6473 43.7145 50.0037 43.7145 50.3753C43.7145 50.7469 43.5688 51.1032 43.3095 51.3659L41.3486 53.347C41.6079 53.6096 41.7536 53.9659 41.7536 54.3375C41.7536 54.7091 41.6079 55.0655 41.3486 55.3281C39.7254 56.9711 36.4234 60.3269 36.4234 60.3269C36.4234 60.3269 36.9459 60.6355 37.7857 61.3974C40.8367 64.1656 42.3473 68.2796 41.8243 72.3966C41.3014 76.5137 38.812 80.1055 35.1688 81.9996H38.4762C40.7642 81.9996 42.619 83.8801 42.619 86.1998V87.5999H43.3095C43.6909 87.5999 44 87.9133 44 88.3C44 88.6866 43.6909 89 43.3095 89H15.6905C15.3091 89 15 88.6866 15 88.3C15 87.9133 15.3091 87.5999 15.6905 87.5999H16.381V86.1998C16.381 83.8801 18.2358 81.9996 20.5238 81.9996H23.8036C20.7706 80.4149 18.5208 77.627 17.5893 74.2992H15.6905C15.3091 74.2992 15 73.9857 15 73.5991C15 73.2125 15.3091 72.8991 15.6905 72.8991H18.7562H20.2752ZM25.2398 67.7048L26.7036 66.2207L24.7495 64.2396L23.2857 65.7237L25.2398 67.7048ZM24.2593 61.7614L29.1479 66.7107L30.1214 65.7237L25.2398 60.7744L24.2593 61.7614ZM42.329 50.3788L40.375 48.3977L38.421 50.3788L40.375 52.3599L42.329 50.3788ZM36.4669 50.3788L26.7036 60.2984L30.6117 64.2606C33.8697 60.9575 37.1246 57.6523 40.375 54.341L36.4669 50.3788ZM20.5238 83.3997C18.9985 83.3997 17.7619 84.6534 17.7619 86.1998V87.5999H41.2381V86.1998C41.2381 84.6534 40.0015 83.3997 38.4762 83.3997H20.5238ZM29.5 81.9996C33.9098 81.9915 37.8924 79.3255 39.6319 75.2171C41.3713 71.1088 40.5343 66.3452 37.5026 63.0985C36.7999 62.346 35.4437 61.2692 35.4437 61.2692L34.0068 62.8173C34.0068 62.8173 35.2866 63.7699 36.1217 64.6876C38.5574 67.3644 39.1845 71.2556 37.7158 74.5792C36.2472 77.9028 32.9656 80.0186 29.374 79.9576C25.7823 79.8967 22.5724 77.6707 21.2143 74.2992H19.0048C20.483 78.9041 24.7236 82.0154 29.5 81.9996Z" fill="#4A2A80"/>
                        </g>
                        </g>
                        <path opacity="0.7" d="M20.1108 29H19.2515L17.9575 27.1909V29H17.2007V25.4307H17.9575V27.1592L19.2368 25.4307H20.0425L18.7412 27.1445L20.1108 29ZM23.3848 29H22.6304V26.0605H21.7563L21.7173 26.3877C21.6164 27.2194 21.5269 27.8037 21.4487 28.1406C21.3722 28.4759 21.2599 28.7119 21.1118 28.8486C20.9637 28.9854 20.7635 29.0521 20.5112 29.0488C20.3745 29.0488 20.2541 29.0309 20.1499 28.9951V28.375C20.2443 28.4076 20.333 28.4238 20.416 28.4238C20.5023 28.4238 20.5706 28.3848 20.6211 28.3066C20.6715 28.2269 20.7188 28.0804 20.7627 27.8672C20.8083 27.6523 20.8677 27.3016 20.9409 26.8149C21.0158 26.3267 21.0793 25.8652 21.1313 25.4307H23.3848V29ZM24.2856 29V25.4307H25.0425V29H24.2856ZM28.8657 29H28.1113V27.4595H26.6978V29H25.9409V25.4307H26.6978V26.8296H28.1113V25.4307H28.8657V29ZM29.769 29V25.4307H30.5259V29H29.769ZM34.166 29H33.4092V27.6206C33.1585 27.7052 32.9494 27.763 32.7817 27.7939C32.6157 27.8249 32.457 27.8403 32.3057 27.8403C31.9655 27.8403 31.7026 27.759 31.5171 27.5962C31.3332 27.4318 31.2412 27.2015 31.2412 26.9053V25.4307H31.9956V26.6904C31.9956 26.863 32.0355 26.9932 32.1152 27.0811C32.195 27.1673 32.3301 27.2104 32.5205 27.2104C32.654 27.2104 32.7866 27.1974 32.9185 27.1714C33.0519 27.1437 33.2155 27.0965 33.4092 27.0298V25.4307H34.166V29ZM37.9917 29H37.2373V27.4595H35.8237V29H35.0669V25.4307H35.8237V26.8296H37.2373V25.4307H37.9917V29ZM40.9507 29H38.895V25.4307H40.9507V26.0508H39.6519V26.8345H40.8604V27.4546H39.6519V28.375H40.9507V29ZM9.67627 34.3701H9.95215C10.1882 33.8981 10.3745 33.4269 10.5112 32.9565C10.6479 32.4845 10.7497 31.9759 10.8164 31.4307H12.8965V34.3701H13.3726V36.04H12.6426V35H10.4062V36.04H9.67627V34.3701ZM11.417 32.0605C11.3649 32.4333 11.2778 32.828 11.1558 33.2446C11.0353 33.6613 10.8994 34.0365 10.748 34.3701H12.1421V32.0605H11.417ZM17.1641 33.2104C17.1641 33.8013 17.0176 34.2554 16.7246 34.5728C16.4316 34.8901 16.0117 35.0488 15.4648 35.0488C14.918 35.0488 14.498 34.8901 14.2051 34.5728C13.9121 34.2554 13.7656 33.7996 13.7656 33.2056C13.7656 32.6115 13.9121 32.1582 14.2051 31.8457C14.4997 31.5316 14.9212 31.3745 15.4697 31.3745C16.0182 31.3745 16.4373 31.5324 16.7271 31.8481C17.0184 32.1639 17.1641 32.618 17.1641 33.2104ZM14.5591 33.2104C14.5591 33.6092 14.6348 33.9095 14.7861 34.1113C14.9375 34.3132 15.1637 34.4141 15.4648 34.4141C16.0687 34.4141 16.3706 34.0129 16.3706 33.2104C16.3706 32.4064 16.0703 32.0044 15.4697 32.0044C15.1686 32.0044 14.9416 32.1061 14.7886 32.3096C14.6356 32.5114 14.5591 32.8117 14.5591 33.2104ZM19.4199 32.0093C19.1351 32.0093 18.9146 32.1167 18.7583 32.3315C18.6021 32.5448 18.5239 32.8426 18.5239 33.2251C18.5239 34.021 18.8226 34.4189 19.4199 34.4189C19.6706 34.4189 19.9741 34.3563 20.3306 34.231V34.8657C20.0376 34.9878 19.7104 35.0488 19.3491 35.0488C18.8299 35.0488 18.4328 34.8918 18.1577 34.5776C17.8826 34.2619 17.7451 33.8094 17.7451 33.2202C17.7451 32.8491 17.8127 32.5244 17.9478 32.2461C18.0828 31.9661 18.2765 31.7521 18.5288 31.604C18.7827 31.4543 19.0798 31.3794 19.4199 31.3794C19.7666 31.3794 20.1149 31.4632 20.4648 31.6309L20.2207 32.2461C20.0872 32.1826 19.953 32.1273 19.8179 32.0801C19.6828 32.0329 19.5501 32.0093 19.4199 32.0093ZM23.917 35H23.1626V32.0605H22.2886L22.2495 32.3877C22.1486 33.2194 22.0591 33.8037 21.981 34.1406C21.9045 34.4759 21.7922 34.7119 21.644 34.8486C21.4959 34.9854 21.2957 35.0521 21.0435 35.0488C20.9067 35.0488 20.7863 35.0309 20.6821 34.9951V34.375C20.7765 34.4076 20.8652 34.4238 20.9482 34.4238C21.0345 34.4238 21.1029 34.3848 21.1533 34.3066C21.2038 34.2269 21.251 34.0804 21.2949 33.8672C21.3405 33.6523 21.3999 33.3016 21.4731 32.8149C21.548 32.3267 21.6115 31.8652 21.6636 31.4307H23.917V35ZM24.8179 35V31.4307H25.5747V35H24.8179ZM26.0483 34.3701H26.3242C26.5602 33.8981 26.7466 33.4269 26.8833 32.9565C27.02 32.4845 27.1217 31.9759 27.1885 31.4307H29.2686V34.3701H29.7446V36.04H29.0146V35H26.7783V36.04H26.0483V34.3701ZM27.7891 32.0605C27.737 32.4333 27.6499 32.828 27.5278 33.2446C27.4074 33.6613 27.2715 34.0365 27.1201 34.3701H28.5142V32.0605H27.7891ZM31.1167 33.1445L29.918 31.4307H30.6968L31.8516 33.1592V31.4307H32.5571V33.1592L33.7119 31.4307H34.4932L33.292 33.1445L34.5615 35H33.751L32.5571 33.1909V35H31.8516V33.1909L30.6577 35H29.8472L31.1167 33.1445ZM37.0688 35H35.0132V31.4307H37.0688V32.0508H35.77V32.8345H36.9785V33.4546H35.77V34.375H37.0688V35ZM40.7407 35H39.9863V33.4595H38.5728V35H37.8159V31.4307H38.5728V32.8296H39.9863V31.4307H40.7407V35ZM44.5688 35H43.8145V33.4595H42.4009V35H41.644V31.4307H42.4009V32.8296H43.8145V31.4307H44.5688V35ZM46.6733 33.6304L45.8384 35H44.9985L46.0142 33.4302C45.8123 33.3488 45.6577 33.2235 45.5503 33.0542C45.4429 32.8833 45.3892 32.6823 45.3892 32.4512C45.3892 32.124 45.5047 31.8726 45.7358 31.6968C45.9686 31.5194 46.3022 31.4307 46.7368 31.4307H47.8989V35H47.1421V33.6304H46.6733ZM47.1421 32.0508H46.7686C46.5732 32.0508 46.4219 32.0858 46.3145 32.1558C46.207 32.2257 46.1533 32.3421 46.1533 32.5049C46.1533 32.6628 46.2054 32.7873 46.3096 32.8784C46.4137 32.9696 46.5732 33.0151 46.7881 33.0151H47.1421V32.0508Z" fill="#4A2A80"/>
                    </svg>
                </div>
                <div class="title">
                    {{articleItem.title}}
                </div>
            </div>

            <div class="author">
                <div class="icon">
                    <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.57171 8C8.62306 8 10.286 6.433 10.286 4.5C10.286 2.567 8.62306 1 6.57171 1C4.52037 1 2.85742 2.567 2.85742 4.5C2.85742 6.433 4.52037 8 6.57171 8Z" stroke="#8F67A4" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.57143 8C9.64856 8 12.1429 10.6862 12.1429 14H1C1 11.915 1.98571 10.0803 3.4828 9.00481" stroke="#8F67A4" stroke-width="0.8" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
                <div class="authors-items">
                    <div class="item" v-for="(author, index) in articleItem.authors" :key="index" @click="openAuthorInfo(author)">
                        {{getShortName(author.name)}}
                    </div>
                </div>
            </div>

            <div class="books">
                <div class="icon">
                    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.27 1.70189H10.9V0.331895C10.9 0.231895 10.86 0.141895 10.78 0.081895C10.71 0.021895 10.61 -0.008105 10.51 0.001895L0.28 1.71189C0.12 1.73189 0 1.87189 0 2.04189V15.3819C0 15.5619 0.15 15.7119 0.33 15.7119H12.26C12.44 15.7119 12.59 15.5619 12.59 15.3819V2.04189C12.6 1.85189 12.45 1.70189 12.27 1.70189ZM11.93 2.37189V15.0419H4.48L6.74 14.6419L10.62 14.0019C10.78 13.9719 10.9 13.8319 10.9 13.6719V2.37189H11.93ZM10.23 0.731895V13.3919L0.67 14.9819V2.32189L10.23 0.731895Z" fill="#4A2A80"/>
                        <path d="M2.6998 5.06182L8.2498 4.20182C8.33981 4.19182 8.41981 4.14182 8.46981 4.07182C8.51981 4.00182 8.5398 3.92182 8.5298 3.83182C8.5198 3.74182 8.4698 3.66182 8.3998 3.61182C8.3298 3.56182 8.2398 3.54182 8.1498 3.55182L2.6398 4.40182C2.5598 4.42182 2.4798 4.46182 2.4298 4.54182C2.3698 4.61182 2.3498 4.70182 2.3698 4.78182C2.3898 4.94182 2.5298 5.06182 2.6998 5.06182Z" fill="#4A2A80"/>
                    </svg>
                </div>
                <div class="books-items">
                    <div class="item" @click="openEditionInfo(articleItem.publisher)">
                        <div class="book-block">{{articleItem.publisher.title}}</div>
                        <div class="book-year">&#8211; {{articleItem.publishYear}}.</div>
                         <div class="number" v-if="articleItem.publishTitle"> &#8211; {{articleItem.publishTitle}}</div>
                    </div>
                </div>
            </div>

             <div class="doi" @click="goToDOI(articleItem.promoLink)">
                <div class="icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M23.2 12C23.2 18.1856 18.1856 23.2 12 23.2C5.81441 23.2 0.8 18.1856 0.8 12C0.8 5.81441 5.81441 0.8 12 0.8C18.1856 0.8 23.2 5.81441 23.2 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM5.41162 16.3171C4.64209 16.3171 4.03662 16.0183 3.59521 15.4207C3.15771 14.823 2.93896 13.9949 2.93896 12.9363C2.93896 11.8621 3.16162 11.0261 3.60693 10.4285C4.05615 9.8269 4.67334 9.52612 5.4585 9.52612C6.28271 9.52612 6.91162 9.84644 7.34521 10.4871H7.40381C7.31396 9.99878 7.26904 9.56323 7.26904 9.18042V7.08276H9.06201V16.2H7.69092L7.34521 15.3503H7.26904C6.86279 15.9949 6.24365 16.3171 5.41162 16.3171ZM6.03857 14.8933C6.49561 14.8933 6.82959 14.7605 7.04053 14.4949C7.25537 14.2292 7.37256 13.7781 7.39209 13.1414V12.948C7.39209 12.2449 7.28271 11.741 7.06396 11.4363C6.84912 11.1316 6.49756 10.9792 6.00928 10.9792C5.61084 10.9792 5.30029 11.1492 5.07764 11.489C4.85889 11.825 4.74951 12.3152 4.74951 12.9597C4.74951 13.6042 4.86084 14.0886 5.0835 14.4128C5.30615 14.7332 5.62451 14.8933 6.03857 14.8933ZM12.355 12.9128C12.355 13.5613 12.4604 14.0515 12.6714 14.3835C12.8862 14.7156 13.2339 14.8816 13.7144 14.8816C14.1909 14.8816 14.5327 14.7175 14.7397 14.3894C14.9507 14.0574 15.0562 13.5652 15.0562 12.9128C15.0562 12.2644 14.9507 11.7781 14.7397 11.4539C14.5288 11.1296 14.1831 10.9675 13.7026 10.9675C13.2261 10.9675 12.8823 11.1296 12.6714 11.4539C12.4604 11.7742 12.355 12.2605 12.355 12.9128ZM16.8843 12.9128C16.8843 13.9792 16.603 14.8132 16.0405 15.4148C15.478 16.0164 14.6948 16.3171 13.6909 16.3171C13.062 16.3171 12.5073 16.1804 12.0269 15.907C11.5464 15.6296 11.1772 15.2332 10.9194 14.7175C10.6616 14.2019 10.5327 13.6003 10.5327 12.9128C10.5327 11.8425 10.812 11.0105 11.3706 10.4167C11.9292 9.823 12.7144 9.52612 13.7261 9.52612C14.355 9.52612 14.9097 9.66284 15.3901 9.93628C15.8706 10.2097 16.2397 10.6023 16.4976 11.114C16.7554 11.6257 16.8843 12.2253 16.8843 12.9128ZM19.2573 7.08276C18.6089 7.08276 18.2847 7.37378 18.2847 7.95581C18.2847 8.54175 18.6089 8.83472 19.2573 8.83472C19.5815 8.83472 19.8237 8.75854 19.9839 8.6062C20.1479 8.44995 20.23 8.23315 20.23 7.95581C20.23 7.37378 19.9058 7.08276 19.2573 7.08276ZM18.3608 16.2H20.1479V9.64917H18.3608V16.2Z" fill="#4A2A80"/>
                    </svg>
                </div>
                <div class="text">
                    {{articleItem.promoNumber ? articleItem.promoNumber : 'Стаття на сайті видавництва'}}
                </div>
            </div>

            <div class="points">
                <div class="anotation item" >

                    <div class="title" @click="isAnotationOpen = !isAnotationOpen">
                        <div class="text">
                            Анотація
                        </div>
                        <div class="open">
                            <div class="line" :class="isAnotationOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isAnotationOpen">
                            {{articleItem.annotation}}
                        </div>
                    </transition>

                </div>

                <div class="key-words item" v-if="articleItem.tags.length > 0">

                    <div class="title" @click="isKeyWordsOpen = !isKeyWordsOpen">
                        <div class="text">
                            Ключові слова
                        </div>
                        <div class="open">
                            <div class="line" :class="isKeyWordsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isKeyWordsOpen">
                            <div v-for="(tag, index) in articleItem.tags" :key="index">
                                {{tag.title}}<span v-if="index !== articleItem.tags.length - 1">,&nbsp;</span>
                            </div>
                            <!-- <div v-for="(word, index) in getProductTags()" :key="index">
                                {{word.title}}<span v-if="index !== getProductTags().length - 1">,&nbsp;</span>
                            </div> -->
                        </div>
                    </transition>

                </div>

                <div class="products item" v-if="articleItem.products.length > 0">

                    <div class="title" @click="isProductsOpen = !isProductsOpen">
                        <div class="text">
                            Згадані продукти
                        </div>
                        <div class="open">
                            <div class="line" :class="isProductsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                    <transition name="fade">
                        <div class="container" v-if="isProductsOpen">
                            <div class="product-label" v-for="(product, index) in articleItem.products" :key="index" @click="openProductInfoPopup(product)" >
                                {{product.title}}
                            </div>
                        </div>
                    </transition>

                </div>

                <div class="dev-algorithms item" v-if="articleItem.algorithms.length > 0">

                    <div class="title" @click="isAlgorithmsOpen = !isAlgorithmsOpen">
                        <div class="text">
                            Розроблені алгоритми
                        </div>
                        <div class="open">
                            <div class="line" :class="isAlgorithmsOpen ? '': 'rotated'"></div>
                            <div class="line"></div>
                        </div>
                    </div>

                     <transition name="fade">
                        <div class="container" v-if="isAlgorithmsOpen">
                            <div v-for="(algorithm, index) in articleItem.algorithms" :key="index" class="algorithm">
                                <div class="icon">
                                    <img :src="$root.globalUrl + algorithm.icon.name" alt="" width="24">
                                </div>
                                <div class="name">{{algorithm.title}}</div>
                                <router-link class="go" :to="getRef(algorithm.link)" tag="a">
                                    перейти
                                </router-link>
                            </div>
                        </div>
                    </transition>

                </div>
            </div>

            <div class="actions-block">
                <div class="read-send">
                    <div class="read" @click="openLanguagePopup('read')">
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.08079 15.8384L3.07161 11.7677H10.1257C11.152 11.7677 11.9869 10.9329 11.9869 9.90656V8.48851C11.9869 8.48706 11.9869 8.48562 11.9868 8.48418V7.27586C11.9868 6.24951 11.152 5.41468 10.1257 5.41468H3.04891V2.39354C3.04891 1.92362 3.43126 1.54119 3.90097 1.54119H4.11173H4.1707H8.60191C9.52645 1.54119 12.7626 1.54125 13.229 1.5704C13.8696 1.61044 14.3884 2.09218 14.3884 2.77613C14.3884 3.14477 14.388 3.47016 14.3876 3.77718C14.387 4.34197 14.3864 4.84458 14.3884 5.43982C14.3884 5.43992 14.3884 5.44001 14.3884 5.44011L14.3884 15.6065C14.3884 16.0764 14.006 16.4588 13.5363 16.4588H3.90103C3.51606 16.4588 3.18379 16.2055 3.08079 15.8384ZM11.3457 8.5473C11.3457 8.54874 11.3457 8.55019 11.3457 8.55163V9.90656C11.3457 10.5792 10.7983 11.1266 10.1257 11.1266H2.2182C1.84499 11.1266 1.54118 10.8227 1.54118 10.4495V5.86832C1.73914 5.9873 1.97084 6.05586 2.2182 6.05586H10.1257C10.7983 6.05586 11.3457 6.60323 11.3457 7.27586V8.5473ZM2.40776 3.41945H2.2182C1.49124 3.41945 0.9 4.01072 0.9 4.73766V10.4495C0.9 11.1765 1.49124 11.7677 2.2182 11.7677H2.43037L2.43979 15.8818L2.4398 15.8822C2.43997 15.9066 2.44292 15.9308 2.44855 15.9544L2.44856 15.9545C2.60968 16.6288 3.20722 17.1 3.901 17.1H13.5363C14.3598 17.1 15.0295 16.4301 15.0295 15.6065L15.0296 4.9493V4.94369V4.93809V4.93251V4.92694V4.92138V4.91583V4.9103V4.90478V4.89927V4.89378V4.8883V4.88283V4.87737V4.87193V4.8665V4.86108V4.85568V4.85029V4.8449V4.83954V4.83418V4.82884V4.82351V4.81819V4.81288V4.80759V4.8023V4.79703V4.79177V4.78653V4.78129V4.77607V4.77086V4.76566V4.76047V4.75529V4.75013V4.74498V4.73984V4.73471V4.72959V4.72448V4.71938V4.7143V4.70923V4.70416V4.69911V4.69407V4.68904V4.68402V4.67902V4.67402V4.66904V4.66406V4.6591V4.65414V4.6492V4.64427V4.63935V4.63444V4.62954V4.62465V4.61977V4.6149V4.61004V4.60519V4.60035V4.59553V4.59071V4.5859V4.5811V4.57631V4.57154V4.56677V4.56201V4.55726V4.55252V4.54779V4.54307V4.53836V4.53366V4.52897V4.52429V4.51962V4.51496V4.5103V4.50566V4.50102V4.4964V4.49178V4.48718V4.48258V4.47799V4.47341V4.46884V4.46427V4.45972V4.45518V4.45064V4.44611V4.44159V4.43708V4.43258V4.42809V4.4236V4.41913V4.41466V4.4102V4.40575V4.4013V4.39687V4.39244V4.38802V4.38361V4.37921V4.37482V4.37043V4.36605V4.36168V4.35731V4.35296V4.34861V4.34427V4.33994V4.33561V4.33129V4.32698V4.32268V4.31838V4.3141V4.30981V4.30554V4.30127V4.29701V4.29276V4.28851V4.28428V4.28004V4.27582V4.2716V4.26739V4.26318V4.25899V4.25479V4.25061V4.24643V4.24226V4.2381V4.23394V4.22978V4.22564V4.2215V4.21736V4.21324V4.20912V4.205V4.20089V4.19679V4.19269V4.1886V4.18451V4.18043V4.17636V4.17229V4.16823V4.16417V4.16012V4.15608V4.15204V4.148V4.14397V4.13995V4.13593V4.13191V4.12791V4.1239V4.1199V4.11591V4.11192V4.10794V4.10396V4.09999V4.09602V4.09206V4.0881V4.08415V4.0802V4.07625V4.07231V4.06838V4.06444V4.06052V4.05659V4.05268V4.04876V4.04485V4.04095V4.03705V4.03315V4.02926V4.02537V4.02148V4.0176V4.01372V4.00985V4.00598V4.00211V3.99825V3.99439V3.99054V3.98669V3.98284V3.97899V3.97515V3.97131V3.96748V3.96365V3.95982V3.956V3.95217V3.94836V3.94454V3.94073V3.93692V3.93311V3.92931V3.92551V3.92171V3.91791V3.91412V3.91033V3.90654V3.90276V3.89897V3.89519V3.89141V3.88764V3.88387V3.88009V3.87633V3.87256V3.86879V3.86503V3.86127V3.85751V3.85376V3.85V3.84625V3.8425V3.83875V3.835V3.83125V3.82751V3.82377V3.82002V3.81628V3.81255V3.80881V3.80507V3.80134V3.79761V3.79387V3.79014V3.78641V3.78268V3.77896V3.77523V3.7715V3.76778V3.76405V3.76033V3.75661V3.75289V3.74916V3.74544V3.74172V3.738V3.73428V3.73056V3.72685V3.72313V3.71941V3.71569V3.71197V3.70826V3.70454V3.70082V3.6971V3.69339V3.68967V3.68595V3.68223V3.67851V3.6748V3.67108V3.66736V3.66364V3.65992V3.6562V3.65247V3.64875V3.64503V3.64131V3.63758V3.63386V3.63013V3.62641V3.62268V3.61895V3.61522V3.61149V3.60776V3.60402V3.60029V3.59655V3.59282V3.58908V3.58534V3.5816V3.57786V3.57411V3.57037V3.56662V3.56287V3.55912V3.55537V3.55161V3.54786V3.5441V3.54034V3.53658V3.53281V3.52905V3.52528V3.52151V3.51774V3.51396V3.51018V3.5064V3.50262V3.49884V3.49505V3.49126V3.48747V3.48367V3.47987V3.47607V3.47227V3.46847V3.46466V3.46084V3.45703V3.45321V3.44939V3.44557V3.44174V3.43791V3.43408V3.43024V3.4264V3.42255V3.41871V3.41486V3.411V3.40714V3.40328V3.39942V3.39555V3.39168V3.3878V3.38392V3.38004V3.37615V3.37226V3.36836V3.36446V3.36056V3.35665V3.35273V3.34882V3.3449V3.34097V3.33704V3.33311V3.32917V3.32522V3.32128V3.31732V3.31336V3.3094V3.30544V3.30146V3.29749V3.29351V3.28952V3.28553V3.28153V3.27753V3.27352V3.26951V3.26549V3.26147V3.25744V3.25341V3.24937V3.24532V3.24128V3.23722V3.23316V3.22909V3.22502V3.22094V3.21686V3.21277V3.20867V3.20457V3.20046V3.19635V3.19223V3.1881V3.18397V3.17983V3.17569V3.17154V3.16738V3.16322V3.15905V3.15487V3.15069V3.1465V3.1423V3.1381V3.13389V3.12967V3.12545V3.12122V3.11698V3.11274V3.10849V3.10423V3.09996V3.09569V3.09141V3.08713V3.08283V3.07853V3.07422V3.06991V3.06558V3.06125V3.05691V3.05257V3.04821V3.04385V3.03948V3.03511V3.03072V3.02633V3.02193V3.01752V3.0131V3.00868V3.00424V2.9998V2.99535V2.9909V2.98643V2.98196V2.97747V2.97298V2.96848V2.96398V2.95946V2.95493V2.9504V2.94586V2.94131V2.93675V2.93218V2.9276V2.92301V2.91842V2.91381V2.9092V2.90457V2.89994V2.8953V2.89065V2.88599V2.88132V2.87664V2.87195V2.86726V2.86255V2.85783V2.85311V2.84837V2.84362V2.83887V2.8341V2.82933V2.82454V2.81975V2.81494V2.81012V2.8053V2.80046V2.79562V2.79076V2.7859V2.78102V2.77613C15.0296 1.90305 14.4136 0.900037 13.2353 0.900011H9.09805H4.1707H4.11173H3.901C3.07751 0.900011 2.40776 1.56995 2.40776 2.39354V3.41945ZM2.2182 4.06063H2.40776V5.41468H2.2182C1.84499 5.41468 1.54118 5.11087 1.54118 4.73766C1.54118 4.36444 1.84497 4.06063 2.2182 4.06063Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.2"/>
                            <mask id="path-2-inside-1" fill="white">
                            <path d="M9.87948 7.42956C9.99206 7.42956 10.0833 7.33832 10.0833 7.22577C10.0833 7.11322 9.99206 7.02197 9.87948 7.02197H8.8288C8.71622 7.02197 8.625 7.11322 8.625 7.22577V9.81818C8.625 9.93073 8.71622 10.022 8.8288 10.022C8.94137 10.022 9.03259 9.93073 9.03259 9.81818V8.70122H9.79603C9.90861 8.70122 9.99983 8.60997 9.99983 8.49742C9.99983 8.38487 9.90861 8.29363 9.79603 8.29363H9.03259V7.42956H9.87948Z"/>
                            </mask>
                            <path d="M9.87948 7.42956C9.99206 7.42956 10.0833 7.33832 10.0833 7.22577C10.0833 7.11322 9.99206 7.02197 9.87948 7.02197H8.8288C8.71622 7.02197 8.625 7.11322 8.625 7.22577V9.81818C8.625 9.93073 8.71622 10.022 8.8288 10.022C8.94137 10.022 9.03259 9.93073 9.03259 9.81818V8.70122H9.79603C9.90861 8.70122 9.99983 8.60997 9.99983 8.49742C9.99983 8.38487 9.90861 8.29363 9.79603 8.29363H9.03259V7.42956H9.87948Z" fill="#8F67A4"/>
                            <path d="M9.03259 8.70122V7.70122H8.03259V8.70122H9.03259ZM9.03259 8.29363H8.03259V9.29363H9.03259V8.29363ZM9.03259 7.42956V6.42956H8.03259V7.42956H9.03259ZM9.87948 8.42956C10.5444 8.42956 11.0833 7.89051 11.0833 7.22577H9.08328C9.08328 6.78612 9.43969 6.42956 9.87948 6.42956V8.42956ZM11.0833 7.22577C11.0833 6.56102 10.5444 6.02197 9.87948 6.02197V8.02197C9.43969 8.02197 9.08328 7.66542 9.08328 7.22577H11.0833ZM9.87948 6.02197H8.8288V8.02197H9.87948V6.02197ZM8.8288 6.02197C8.16385 6.02197 7.625 6.56102 7.625 7.22577H9.625C9.625 7.66542 9.26859 8.02197 8.8288 8.02197V6.02197ZM7.625 7.22577V9.81818H9.625V7.22577H7.625ZM7.625 9.81818C7.625 10.4829 8.16385 11.022 8.8288 11.022V9.02197C9.26859 9.02197 9.625 9.37853 9.625 9.81818H7.625ZM8.8288 11.022C9.49374 11.022 10.0326 10.4829 10.0326 9.81818H8.03259C8.03259 9.37853 8.389 9.02197 8.8288 9.02197V11.022ZM10.0326 9.81818V8.70122H8.03259V9.81818H10.0326ZM9.03259 9.70122H9.79603V7.70122H9.03259V9.70122ZM9.79603 9.70122C10.461 9.70122 10.9998 9.16217 10.9998 8.49742H8.99983C8.99983 8.05777 9.35624 7.70122 9.79603 7.70122V9.70122ZM10.9998 8.49742C10.9998 7.83267 10.461 7.29363 9.79603 7.29363V9.29363C9.35624 9.29363 8.99983 8.93707 8.99983 8.49742H10.9998ZM9.79603 7.29363H9.03259V9.29363H9.79603V7.29363ZM10.0326 8.29363V7.42956H8.03259V8.29363H10.0326ZM9.03259 8.42956H9.87948V6.42956H9.03259V8.42956Z" fill="#8F67A4" mask="url(#path-2-inside-1)"/>
                            <mask id="path-4-inside-2" fill="white">
                            <path d="M5.75555 7.02197C5.70145 7.02197 5.64955 7.04349 5.61129 7.08181C5.57309 7.12012 5.55165 7.17205 5.55176 7.22617V7.2284V7.22848V9.77609C5.55176 9.79196 5.55374 9.80734 5.55719 9.82214C5.55823 9.87502 5.57966 9.92551 5.61722 9.96282C5.65539 10.0007 5.70702 10.022 5.7608 10.022H5.76156C5.7837 10.0219 6.30645 10.0199 6.51481 10.0162C6.87648 10.0099 7.19848 9.84608 7.42159 9.55493C7.62718 9.28657 7.74044 8.91974 7.74044 8.52199C7.74044 7.6248 7.23782 7.022 6.48976 7.022H5.75555V7.02197ZM7.33285 8.52199C7.33285 9.15334 6.99354 9.60022 6.50769 9.6087C6.38376 9.61088 6.13953 9.61248 5.96389 9.61343C5.96288 9.31608 5.9612 8.77176 5.9612 8.51913C5.9612 8.3077 5.96025 7.73765 5.95967 7.42959H6.48973C6.89735 7.42956 7.33285 7.71656 7.33285 8.52199Z"/>
                            </mask>
                            <path d="M5.75555 7.02197C5.70145 7.02197 5.64955 7.04349 5.61129 7.08181C5.57309 7.12012 5.55165 7.17205 5.55176 7.22617V7.2284V7.22848V9.77609C5.55176 9.79196 5.55374 9.80734 5.55719 9.82214C5.55823 9.87502 5.57966 9.92551 5.61722 9.96282C5.65539 10.0007 5.70702 10.022 5.7608 10.022H5.76156C5.7837 10.0219 6.30645 10.0199 6.51481 10.0162C6.87648 10.0099 7.19848 9.84608 7.42159 9.55493C7.62718 9.28657 7.74044 8.91974 7.74044 8.52199C7.74044 7.6248 7.23782 7.022 6.48976 7.022H5.75555V7.02197ZM7.33285 8.52199C7.33285 9.15334 6.99354 9.60022 6.50769 9.6087C6.38376 9.61088 6.13953 9.61248 5.96389 9.61343C5.96288 9.31608 5.9612 8.77176 5.9612 8.51913C5.9612 8.3077 5.96025 7.73765 5.95967 7.42959H6.48973C6.89735 7.42956 7.33285 7.71656 7.33285 8.52199Z" fill="#8F67A4"/>
                            <path d="M5.75555 7.02197H6.75555V6.02197H5.75555V7.02197ZM5.61129 7.08181L4.90368 6.3752L4.90318 6.37571L5.61129 7.08181ZM5.55176 7.22617H6.55176L6.55176 7.22417L5.55176 7.22617ZM5.55719 9.82214L6.557 9.80262L6.55495 9.69755L6.5311 9.5952L5.55719 9.82214ZM5.61722 9.96282L4.91242 10.6722L4.91264 10.6724L5.61722 9.96282ZM5.76156 10.022V11.022L5.76524 11.022L5.76156 10.022ZM6.51481 10.0162L6.49738 9.01639L6.49734 9.01639L6.51481 10.0162ZM7.42159 9.55493L8.21534 10.1632L8.21542 10.1631L7.42159 9.55493ZM5.75555 7.022H4.75555V8.022H5.75555V7.022ZM6.50769 9.6087L6.49025 8.60886L6.49016 8.60886L6.50769 9.6087ZM5.96389 9.61343L4.96389 9.61681L4.96728 10.6188L5.9693 10.6134L5.96389 9.61343ZM5.95967 7.42959V6.42959H4.95782L4.95968 7.43144L5.95967 7.42959ZM6.48973 7.42959V8.42959H6.4898L6.48973 7.42959ZM5.75555 6.02197C5.43586 6.02197 5.12943 6.14914 4.90368 6.3752L6.3189 7.78841C6.16968 7.93785 5.96705 8.02197 5.75555 8.02197V6.02197ZM4.90318 6.37571C4.67783 6.6017 4.55112 6.90826 4.55176 7.22818L6.55176 7.22417C6.55218 7.43584 6.46835 7.63854 6.3194 7.78791L4.90318 6.37571ZM4.55176 7.22617V7.2284H6.55176V7.22617H4.55176ZM4.55176 7.2284V7.22848H6.55176V7.2284H4.55176ZM4.55176 7.22848V9.77609H6.55176V7.22848H4.55176ZM4.55176 9.77609C4.55176 9.8758 4.56427 9.9675 4.58329 10.0491L6.5311 9.5952C6.54321 9.64718 6.55176 9.70811 6.55176 9.77609H4.55176ZM4.55738 9.84167C4.56345 10.1523 4.68945 10.4507 4.91242 10.6722L6.32201 9.2534C6.46988 9.40031 6.553 9.59776 6.557 9.80262L4.55738 9.84167ZM4.91264 10.6724C5.13835 10.8965 5.44333 11.022 5.7608 11.022V9.02197C5.97071 9.02197 6.17244 9.1049 6.32179 9.25319L4.91264 10.6724ZM5.7608 11.022H5.76156V9.02197H5.7608V11.022ZM5.76524 11.022C5.78401 11.0219 6.31528 11.0199 6.53229 11.0161L6.49734 9.01639C6.29762 9.01988 5.7834 9.02189 5.75788 9.02198L5.76524 11.022ZM6.53224 11.0161C7.20395 11.0044 7.80983 10.6924 8.21534 10.1632L6.62785 8.94668C6.58713 8.99982 6.54901 9.01549 6.49738 9.01639L6.53224 11.0161ZM8.21542 10.1631C8.57727 9.69075 8.74044 9.0994 8.74044 8.52199H6.74044C6.74044 8.74008 6.6771 8.88239 6.62777 8.94678L8.21542 10.1631ZM8.74044 8.52199C8.74044 7.89303 8.56381 7.27506 8.16367 6.79515C7.75054 6.29967 7.15421 6.022 6.48976 6.022V8.022C6.54039 8.022 6.56765 8.03165 6.58057 8.03764C6.59345 8.0436 6.60905 8.05372 6.62757 8.07594C6.66575 8.12173 6.74044 8.25375 6.74044 8.52199H8.74044ZM6.48976 6.022H5.75555V8.022H6.48976V6.022ZM6.75555 7.022V7.02197H4.75555V7.022H6.75555ZM6.33285 8.52199C6.33285 8.66665 6.29347 8.71073 6.30603 8.6942C6.31373 8.68406 6.33498 8.6608 6.37411 8.64011C6.41471 8.61864 6.45684 8.60944 6.49025 8.60886L6.52514 10.6086C7.77821 10.5867 8.33285 9.44621 8.33285 8.52199H6.33285ZM6.49016 8.60886C6.37355 8.6109 6.13597 8.61248 5.95847 8.61345L5.9693 10.6134C6.14309 10.6125 6.39397 10.6109 6.52523 10.6085L6.49016 8.60886ZM6.96388 9.61005C6.96287 9.31214 6.9612 8.7697 6.9612 8.51913H4.9612C4.9612 8.77381 4.96289 9.32002 4.96389 9.61681L6.96388 9.61005ZM6.9612 8.51913C6.9612 8.30656 6.96024 7.73543 6.95967 7.42774L4.95968 7.43144C4.96025 7.73986 4.9612 8.30884 4.9612 8.51913H6.9612ZM5.95967 8.42959H6.48973V6.42959H5.95967V8.42959ZM6.4898 8.42959C6.47533 8.42959 6.45097 8.42712 6.42019 8.41474C6.38712 8.40143 6.35519 8.37992 6.33075 8.35355C6.30638 8.32725 6.30466 8.31265 6.31071 8.33062C6.31754 8.3509 6.33285 8.40954 6.33285 8.52199H8.33285C8.33285 7.94163 8.17342 7.39945 7.79754 6.99394C7.42062 6.58731 6.92811 6.42956 6.48967 6.42959L6.4898 8.42959Z" fill="#8F67A4" mask="url(#path-4-inside-2)"/>
                            <mask id="path-6-inside-3" fill="white">
                            <path d="M3.20253 7.00003C3.14872 7.00003 3.09712 7.02144 3.0591 7.05956C3.02136 7.09742 3.00019 7.14866 3.00005 7.2021C3.00005 7.20226 3 7.2024 3 7.20253V9.7975C3 9.90933 3.09064 10 3.2025 10C3.31437 10 3.40501 9.90933 3.40501 9.7975V8.8717C3.57306 8.87078 3.80615 8.86962 3.92506 8.86962C4.44842 8.86962 4.87419 8.45028 4.87419 7.93481C4.87419 7.41935 4.44839 7 3.92506 7H3.20253V7.00003ZM4.46921 7.93484C4.46921 8.22202 4.22002 8.46464 3.92509 8.46464C3.80683 8.46464 3.57697 8.46578 3.40892 8.4667C3.408 8.29413 3.40684 8.0555 3.40684 7.93484C3.40684 7.83305 3.4062 7.58451 3.40566 7.40503H3.92509C4.22002 7.40503 4.46921 7.64763 4.46921 7.93484Z"/>
                            </mask>
                            <path d="M3.20253 7.00003C3.14872 7.00003 3.09712 7.02144 3.0591 7.05956C3.02136 7.09742 3.00019 7.14866 3.00005 7.2021C3.00005 7.20226 3 7.2024 3 7.20253V9.7975C3 9.90933 3.09064 10 3.2025 10C3.31437 10 3.40501 9.90933 3.40501 9.7975V8.8717C3.57306 8.87078 3.80615 8.86962 3.92506 8.86962C4.44842 8.86962 4.87419 8.45028 4.87419 7.93481C4.87419 7.41935 4.44839 7 3.92506 7H3.20253V7.00003ZM4.46921 7.93484C4.46921 8.22202 4.22002 8.46464 3.92509 8.46464C3.80683 8.46464 3.57697 8.46578 3.40892 8.4667C3.408 8.29413 3.40684 8.0555 3.40684 7.93484C3.40684 7.83305 3.4062 7.58451 3.40566 7.40503H3.92509C4.22002 7.40503 4.46921 7.64763 4.46921 7.93484Z" fill="#8F67A4"/>
                            <path d="M3.20253 7.00003V8.00003H4.20253V7.00003H3.20253ZM3.0591 7.05956L2.35099 6.35346L2.35099 6.35347L3.0591 7.05956ZM3.00005 7.2021L2.00005 7.19957V7.2021H3.00005ZM3.40501 8.8717L3.39955 7.87172L2.40501 7.87715V8.8717H3.40501ZM3.20253 7V6H2.20253V7H3.20253ZM3.40892 8.4667L2.40894 8.47202L2.41426 9.47214L3.41439 9.46668L3.40892 8.4667ZM3.40566 7.40503V6.40503H2.40264L2.40566 7.40804L3.40566 7.40503ZM3.20253 6.00003C2.88299 6.00003 2.57662 6.1272 2.35099 6.35346L3.76721 7.76567C3.61762 7.91568 3.41444 8.00003 3.20253 8.00003V6.00003ZM2.35099 6.35347C2.12616 6.57894 2.00086 6.8834 2.00006 7.19957L4.00005 7.20462C3.99952 7.41393 3.91655 7.6159 3.76722 7.76566L2.35099 6.35347ZM2.00005 7.2021C2.00005 7.1466 2.0047 7.10067 2.00898 7.06886C2.0111 7.05306 2.01324 7.04009 2.01475 7.03133C2.0162 7.02302 2.01745 7.01646 2.0176 7.01568C2.01764 7.01547 2.01771 7.01509 2.01766 7.01536C2.01764 7.01546 2.01755 7.01593 2.01744 7.01652C2.01722 7.01768 2.01675 7.0202 2.01616 7.0234C2.01504 7.02959 2.01295 7.04135 2.01076 7.05619C2.00854 7.07122 2.00588 7.09155 2.00377 7.11571C2.00166 7.14001 2 7.16929 2 7.20253H4C4 7.23573 3.99834 7.26499 3.99623 7.28925C3.99413 7.31338 3.99147 7.33367 3.98926 7.34867C3.98707 7.36348 3.98499 7.3752 3.98387 7.38135C3.98329 7.38454 3.98282 7.38704 3.9826 7.38818C3.98249 7.38877 3.98241 7.38923 3.98239 7.38931C3.98234 7.38958 3.98241 7.38919 3.98246 7.38897C3.98261 7.38815 3.98387 7.38156 3.98532 7.37321C3.98684 7.36442 3.98898 7.35141 3.99111 7.33557C3.9954 7.30368 4.00005 7.25767 4.00005 7.2021H2.00005ZM2 7.20253V9.7975H4V7.20253H2ZM2 9.7975C2 10.4615 2.53827 11 3.2025 11V9C3.64301 9 4 9.35713 4 9.7975H2ZM3.2025 11C3.86674 11 4.40501 10.4615 4.40501 9.7975H2.40501C2.40501 9.35713 2.762 9 3.2025 9V11ZM4.40501 9.7975V8.8717H2.40501V9.7975H4.40501ZM3.41047 9.87169C3.5794 9.87076 3.80947 9.86962 3.92506 9.86962V7.86962C3.80284 7.86962 3.56672 7.8708 3.39955 7.87172L3.41047 9.87169ZM3.92506 9.86962C4.98632 9.86962 5.87419 9.01684 5.87419 7.93481H3.87419C3.87419 7.92476 3.87648 7.91338 3.88087 7.90318C3.88494 7.89371 3.8899 7.88726 3.89417 7.88306C3.90274 7.87461 3.91497 7.86962 3.92506 7.86962V9.86962ZM5.87419 7.93481C5.87419 6.85277 4.98627 6 3.92506 6V8C3.91495 8 3.90272 7.995 3.89417 7.98657C3.8899 7.98238 3.88495 7.97593 3.88087 7.96646C3.87648 7.95626 3.87419 7.94487 3.87419 7.93481H5.87419ZM3.92506 6H3.20253V8H3.92506V6ZM2.20253 7V7.00003H4.20253V7H2.20253ZM3.46921 7.93484C3.46921 7.78353 3.53468 7.66442 3.61013 7.59096C3.68552 7.51756 3.79546 7.46464 3.92509 7.46464V9.46464C4.747 9.46464 5.46921 8.79927 5.46921 7.93484H3.46921ZM3.92509 7.46464C3.80353 7.46464 3.5707 7.4658 3.40346 7.46671L3.41439 9.46668C3.58325 9.46576 3.81013 9.46464 3.92509 9.46464V7.46464ZM4.40891 8.46138C4.40799 8.28793 4.40684 8.05227 4.40684 7.93484H2.40684C2.40684 8.05874 2.40802 8.30034 2.40894 8.47202L4.40891 8.46138ZM4.40684 7.93484C4.40684 7.83123 4.40619 7.58104 4.40565 7.40203L2.40566 7.40804C2.4062 7.58798 2.40684 7.83487 2.40684 7.93484H4.40684ZM3.40566 8.40503H3.92509V6.40503H3.40566V8.40503ZM3.92509 8.40503C3.79549 8.40503 3.68555 8.35214 3.61014 8.27872C3.53467 8.20524 3.46921 8.08612 3.46921 7.93484H5.46921C5.46921 7.07035 4.74697 6.40503 3.92509 6.40503V8.40503Z" fill="#8F67A4" mask="url(#path-6-inside-3)"/>
                        </svg>
                        читати
                    </div>
                    <div class="send" @click="openLanguagePopup('send2')">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.0315 9.02942L17.0622 8.99573L17.0315 8.96204L9.7397 0.966308L9.65276 0.87097V1V5.73955H8.85571C6.74419 5.73955 4.75869 6.56196 3.26555 8.0551C1.77241 9.54824 0.95 11.5337 0.95 13.6454V17V17.129L1.03693 17.0337L2.43635 15.5004C4.28757 13.4722 6.91073 12.2937 9.65276 12.253V16.9916V17.1206L9.7397 17.0253L17.0315 9.02942ZM15.658 8.99573L10.6903 14.443V11.2644V11.2144H10.6403H9.79907C6.86704 11.2144 4.04602 12.3946 1.98762 14.4673V13.6454C1.98762 11.8107 2.70196 10.086 3.99922 8.78877C5.29649 7.49151 7.02107 6.77717 8.85571 6.77717H10.6403H10.6903V6.72717V3.54858L15.658 8.99573Z" fill="#8F67A4" stroke="#8F67A4" stroke-width="0.1"/>
                        </svg>
                        надіслати
                    </div>
                </div>
                <div class="download" @click="openLanguagePopup('download')">
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 12.4436H12" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M6.46484 8.08519V1" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                        <path d="M9.68072 5.66956L6.46463 8.85293L3.24854 5.66956" stroke="white" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                    </svg>
                    завантажити
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import AuthorPopup from '../library-items/popups/author-popup';
import EditionPopup from '../library-items/popups/edition-popup';
import ProductPopup from '../library-items/popups/product-popup';
import LanguagePopup from '../library-items/popups/language-popup';

export default {
    props : ['articleItem'],
    components : {
        'author-popup' : AuthorPopup,
        'edition-popup' : EditionPopup,
        'product-popup' : ProductPopup,
        'language-popup' : LanguagePopup
    },
    created(){
        this.articleItem.products.sort((a, b) => {
            if(a.position < b.position) { return -1; }
            if(a.position > b.position) { return 1; }
            return 0;
        })
    },
    data : () => ({
        isAnotationOpen : false,
        isKeyWordsOpen : false,
        isProductsOpen : false,
        isAlgorithmsOpen : false,

        isAuthorInfoOpen : false,
        isEditionInfoOpen : false,
        isProductInfoOpen : false,
        action : '',

        authorInfo : {},
        authorTestInfo : {
            fullName : 'Дмитро Олександрович Добрянський',
            awards : 'д.м.н., професор кафедри педіатрії №2 Львівського національного медичного університету ім. Данила Галицького',
            email : 'dobryanskiy@gmail.com',
            materials : [
                {
                    id : 2,
                    them : 'Використання білкової добавки для забезпечення харчових потреб значно недоношених дітей',
                    subtitle : 'Відеоматеріал, 2020'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'Здоров’я дитини. – 2019. – №3'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'Здоров’я дитини. – 2019. – №3'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'Здоров’я дитини. – 2019. – №3'
                },
            ]
        },

        editionInfo : {},
        editionTestInfo : {
            name : '«Здоров’я дитини»',
            description : 'спеціалізований рецензований науково-практичний журнал, заснований в 2006 році, виходить з періодичністю 8 разів на рік',
            materials : [
                {
                    id : 2,
                    them : 'Використання білкової добавки для забезпечення харчових потреб значно недоношених дітей',
                    subtitle : 'Д.О. Добрянський, – 2020. – №1'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'С.Л. Няньковський та ін. – 2019. – №3'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'Здоров’я дитини. – 2019. – №3'
                },
                {
                    id : 3,
                    them : 'Харчова алергія на білок коров’ячого молока чи непереносимість лактози? Принципи диференціальної діагностики й дієтотерапії',
                    subtitle : 'Здоров’я дитини. – 2019. – №3'
                },
            ]
        },

        productInfo : {},
        productTestInfo : {
            name : 'Суміш суха Nutrilon Пепті',
            description : 'комплексне рішення при харчовій алергії на білок коров’ячого молока',
            useFor : 'Алергія на БКМ',
            image : ''
        }
    }),
    mounted(){
        const UNAUTHORIZED = 401;
          axios.interceptors.response.use(
            response => response,
            error => {
              const {status} = error.response;
              if (status === UNAUTHORIZED) {
                sessionStorage.removeItem('key');
              }
              return Promise.reject(error);
            }
          );
    },
    methods : {
        goToDOI(link){
            if(link != null)
                window.open(link, '_blank');
        },
        getShortName(name){
            name = name.split(" ");
            return name[0].substring(0,1) + '.' + name[1].substring(0,1) + '. ' + name[2];
        },
        getRef(str){
            return str.substring(6);
        },
        getProductTags(){
            let tags = [];

            for(let i = 0; i < this.articleItem.products.length; i++){
                tags = tags.concat(this.articleItem.products[i].tags)
            }

            return tags;
        },
        openAuthorInfo(author){
        
            axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("key");

            axios.post(this.$root.globalUrl + "api/v1/library-clinical/author/" + author.id)
            .then(res => {

                this.removeScroll();

                this.authorInfo = res.data.data;

                this.isAuthorInfoOpen = true;
            })
        },
        openEditionInfo(publisher){
            axios.defaults.headers.common['Authorization'] = sessionStorage.getItem("key");

            axios.post(this.$root.globalUrl + "api/v1/library-clinical/publisher/" + publisher.id).then(res => {
                this.removeScroll();



                this.editionInfo = res.data.data;

                this.isEditionInfoOpen = true;                
            })

        },
        openProductInfoPopup(product){
            this.removeScroll();

            this.productInfo = product;

            this.isProductInfoOpen = true;
        },
        openLanguagePopup(action){
            if(this.articleItem.contentRu || this.articleItem.contentEn){
                this.action = action;
                this.removeScroll();
            }
            else{
                switch(action){
                    case 'read' : {
                        let a  = document.createElement('a');
                        a.href = this.$root.globalUrl + this.articleItem.contentUa.name;
                        a.target = "_blank";
                        a.click();
                    }
                    break;
                    case 'download' : {
                        let a  = document.createElement('a');
                        a.href = this.$root.globalUrl + this.articleItem.contentUa.name;
                        a.setAttribute('download', "download");
                        a.click();
                    }
                    break;
                    case 'send2' : {
                        document
                            .getElementById("viber_share")
                            .setAttribute(
                                "href",
                                "https://3p3x.adj.st/?adjust_t=u783g1_kw9yml&adjust_fallback=https%3A%2F%2Fwww.viber.com%2F%3Futm_source%3DPartner%26utm_medium%3DSharebutton%26utm_campaign%3DDefualt&adjust_campaign=Sharebutton&adjust_deeplink=" +
                                encodeURIComponent(
                                    "viber://forward?text=" +
                                    encodeURIComponent(this.$root.globalUrl + this.articleItem.contentUa.name)
                                )
                            );
                        document.getElementById("viber_share").click();
                    }
                    break;
                }
            }
        },
        closePopup(){
            this.isAuthorInfoOpen = false;
            this.isEditionInfoOpen = false;
            this.isProductInfoOpen = false;
            this.action = '';
            this.addScroll();
        },
        removeScroll(){
            if(window.screen.width > 426){
                document.getElementsByTagName("body")[0].style.overflow = "visible";
            }
            else{
                document.getElementsByTagName("body")[0].style.overflow = "hidden";
            }
        },
        addScroll(){
            document.getElementsByTagName("body")[0].style.overflow = "visible";
        }
    }
}
</script>

<style lang="scss" scoped>
.scientific-article{
    padding: 15px 15px 60px;
    border-radius: 4px;

    .article-header{
        background: #EFE1F7;
        padding: 10px 15px 15px 15px;

        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .article-type{
            font-size: 12px;
            color: #4A2A80;
        }

        .language{
            display: flex;
            flex-direction: row;

            font-weight: 600;
            font-size: 12px;
            color: #8F67A4;

            .delimetr{
                padding: 0 5px;
            }
        }
    }

    .article-content{
        background: #FFFFFF;

        .article-title{
            padding: 20px 15px;

            display: flex;
            flex-direction: row;

            align-items: center;

            border-bottom: 1px solid #EFE1F7;

            .image{
                padding-right: 14px;
            }

            .title{
                font-weight: 600;
                font-size: 13px;
                line-height: 130%;
                color: #4A2A80;
            }
        }

        .author{
            padding: 20px 5px 15px 16px;

            display: flex;
            flex-direction: row;

            .icon{
                padding-right: 9px;
            }

            .authors-items{
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;

                font-size: 10px;
                color: #4A2A80;

                .item{
                    padding: 4px 4px;
                    border: 0.606867px solid #AC98C5;
                    box-sizing: border-box;
                    border-radius: 4px;

                    margin-right: 5px;
                    margin-bottom: 8px;
                    cursor: pointer;
                }
            }
        }

        .books{
            padding: 5px 5px 27px 16px;

            display: flex;
            flex-direction: row;

            border-bottom: 1px solid #EFE1F7;

            .icon{
                padding-right: 9px;
            }

            .books-items{
                font-size: 10px;
                color: #4A2A80;

                display: flex;
                flex-direction: column;

                .item{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    flex-wrap: wrap;
                    cursor: pointer;
                    margin-bottom: 8px;

                    .book-block{
                        padding: 4px 4px;
                        border: 0.606867px solid #AC98C5;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }

                    .book-year{
                        padding: 0 5px;
                    }
                }
            }
        }

        .doi{
            padding: 17px 15px 20px 16px;

            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            border-bottom: 1px solid #EFE1F7;

            .icon{
                padding-right: 10px;
            }

            .text{
                text-decoration-line: underline;
                font-size: 12px;
                color: #8F67A4;
            }
        }

        .points{
            .item{
                padding: 13px 20px 17px 15px;

                border-bottom: 1px solid #EFE1F7;
                cursor: pointer;

                .title{
                    font-weight: 600;
                    font-size: 14px;
                    color: #4A2A80;

                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .open{
                        width: 20px;
                        height: 20px;

                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: relative;

                        .line{
                            width: 100%;
                            height: 2px;
                            background: #8F67A4;

                            position: absolute;
                            transition: transform 500ms ease;
                        }

                        .rotated{
                            transform: rotate(-90deg);
                            transition: transform 500ms ease;
                        }
                    }
                }

                .container{
                    padding-top: 10px;

                    font-size: 12px;
                    color: #4A2A80;
                    font-weight: 300;
                    line-height: 135%;
                }

            }

            .key-words, .products{
                .container{
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                }
            }

            .products{
                .container{
                    padding-top: 20px;

                    .product-label{
                        display: flex;

                        margin-right: 10px;
                        margin-bottom: 10px;

                        padding: 4px 4px;
                        border: 0.606867px solid #AC98C5;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }
                }
            }

            .dev-algorithms{
                .container{
                    padding-top: 20px;

                    .algorithm{
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        margin-bottom: 20px;

                        .icon{
                            flex-grow: 1;
                        }

                        .name{
                            font-size: 13px;
                            color: #4A2A80;

                            padding-left: 10px;
                            padding-right: 10px;

                            flex-grow: 10;

                            width: 50%;
                        }

                        .go{
                            flex-grow: 1;
                            padding: 10px 20px;

                            color: #8F67A4;
                            text-transform: uppercase;
                            font-weight: bold;
                            font-size: 13px;

                            border: 1px solid #8F67A4;
                            box-sizing: border-box;
                            border-radius: 4px;
                        }
                    }
                }
            }
        }

        .actions-block{
            padding: 30px 15px;

            .read-send{
                display: flex;
                flex-direction: row;
                padding-bottom: 19px;

                .read, .send{
                    flex-grow: 1;
                    flex-basis: 0;

                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    padding: 11px 0;

                    border: 1px solid #8F67A4;
                    box-sizing: border-box;
                    border-radius: 4px;

                    color: #8F67A4;
                    text-transform: uppercase;
                    font-weight: bold;
                    font-size: 13px;
                    cursor: pointer;

                    svg{
                        margin-right: 9px;
                    }
                }

                .read{
                    margin-right: 10px;
                }
            }

            .download{
                padding: 10px 0;
                background: #8F67A4;
                border-radius: 4px;
                text-align: center;
                font-weight: bold;
                font-size: 15px;
                line-height: 20px;
                text-transform: uppercase;
                color: #FFFFFF;

                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                svg{
                    margin-right: 10px;
                }
            }
        }
    }


}
</style>
